import { render, staticRenderFns } from "./SellBusinessDetails.vue?vue&type=template&id=58e981fc&scoped=true&"
import script from "./SellBusinessDetails.vue?vue&type=script&lang=js&"
export * from "./SellBusinessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e981fc",
  null
  
)

export default component.exports